import Phaser from 'phaser'
import Editable from './editable'
import ObstacleEditor from '../editor/obstacleEditor'
import Platform from './platform'

const WIDTH = 105
const HEIGHT = 125

export default class RepeatingPlatformManager extends Platform {
  constructor (scene, args, doSave = true) {
    super(scene, args, doSave)
    this.typeName = 'rPl'

    this.nPlatforms = args.nPlatforms || 2
    this.addEditableProperty('nPlatforms', (value) => { this.setNPlatforms(value) }, () => { return this.nPlatforms })

    this.spawnPlatforms()
    this.hide()

    this.countdown = args.countdown || 6
    this.addEditableProperty('countdown', (value) => { this.setCountdown(value) }, () => { return this.countdown })
    this.countDownTimer = 0.01

    this.speed = args.speed
    this.addEditableProperty('speed', (value) => { this.setSpeed(value) }, () => { return this.speed })

    this.speedX = args.speedX || 0
    this.addEditableProperty('speedX', (value) => { this.setSpeedX(value) }, () => { return this.speedX })
  }

  spawnPlatforms () {
    this.platforms = []
    for (var i = 0; i < this.nPlatforms; i++) {
      var def = { type: 'sPl', data: { x: this.image.x, y: this.image.y, width: this.image.width, height: this.image.height, bounceMP: this.bounceMP } }
      var pl = this.scene.spawner.spawnFromDef(def, false, false)
      pl.image.setFriction(0, 0, 0)
      pl.hide()
      pl.hideEditing()
      this.platforms.push(pl)
    }

    this.lastPlatformIndex = 0
    // this.countDownTimer = 0.0
  }

  setNPlatforms (value) {
    // destroy all old platforms
    for (var i = 0; i < this.nPlatforms; i++) {
      this.scene.levelEditor.deleteObject(this.platforms[i])
    }

    this.nPlatforms = value

    // and create a bunch of new ones
    this.spawnPlatforms()
  }

  setCountdown (value) {
    this.countdown = value
    this.countDownTimer = 0.01
  }

  setSpeed (value) {
    this.speed = value
  }

  setSpeedX (value) {
    this.speedX = value
  }

  preUpdate (time, delta) {
    super.preUpdate(time, delta)

    this.countDownTimer -= delta * 0.001
    if (this.countDownTimer <= 0) {
      this.countDownTimer = this.countdown

      this.platforms[this.lastPlatformIndex].image.x = this.image.x
      this.platforms[this.lastPlatformIndex].image.y = this.image.y
      this.platforms[this.lastPlatformIndex].image.setScale(this.image.scaleX, this.image.scaleY)
      this.platforms[this.lastPlatformIndex].image.setVelocity(this.speedX, -1 * this.speed)

      this.platforms[this.lastPlatformIndex].colorIm.x = this.image.x
      this.platforms[this.lastPlatformIndex].colorIm.y = this.image.y
      this.platforms[this.lastPlatformIndex].colorIm.setScale(this.image.scaleX - 10, this.image.scaleY - 10)
      this.platforms[this.lastPlatformIndex].colorIm.setVelocity(this.speedX, -1 * this.speed)

      this.platforms[this.lastPlatformIndex].setBounceMP(this.bounceMP)
      this.platforms[this.lastPlatformIndex].show()
      this.lastPlatformIndex++
      if (this.lastPlatformIndex >= this.platforms.length) {
        this.lastPlatformIndex = 0
      }
    }
  }

  showEditing () {
    super.showEditing()
    this.show()
    for (var i = 0; i < this.nPlatforms; i++) {
      this.platforms[i].hideEditing()
    }
  }

  hideEditing () {
    super.hideEditing()
    this.hide()
  }
}
